import {emotionStyled, tokens} from '@packages/utilities/styled';
import {disabledSelector, hoverSelector} from '../../../utils';
import {BUTTON_POSITIONS, NUMBER_INPUT_VARIANTS} from '../_constants';

const outOfBoundsStyles = {
  opacity: tokens.opacities.disabled,
  cursor: 'not-allowed',
};

export const NumberInputButtonView = emotionStyled('button')(
  {
    alignItems: 'center',
    appearance: 'none',
    background: '$actionSecondaryBackground',
    border: 'none',
    cursor: tokens.ui.activeCursor,
    color: '$textPrimary',
    display: 'flex',
    boxSizing: 'border-box',
    justifyContent: 'center',
    margin: '0',
    padding: '0',
    position: 'unset',
    textAlign: 'center',
    overflow: 'hidden',
    svg: {
      color: '$textSecondary',
    },
    [hoverSelector]: {
      background: '$actionSecondaryBackgroundHover',
    },
    [disabledSelector('')]: outOfBoundsStyles,
  },
  {
    componentName: 'NumberInputButton',
    variants: {
      inputVariant: {
        [NUMBER_INPUT_VARIANTS.DEFAULT]: {
          width: '100%',
          height: '100%',
        },
        [NUMBER_INPUT_VARIANTS.STEPPER]: {
          width: tokens.ui.numberInput.stepper.button.width,
          height: tokens.ui.numberInput.stepper.button.height,
        },
      },
      isMax: {
        true: outOfBoundsStyles,
      },
      isMin: {
        true: outOfBoundsStyles,
      },
      position: {
        [BUTTON_POSITIONS.TOP]: {
          borderRadius: '0 $2 0 0',
        },
        [BUTTON_POSITIONS.BOTTOM]: {
          borderRadius: '0 0 $2 0',
        },
        [BUTTON_POSITIONS.LEADING]: {
          borderRadius: '$2 0 0 $2',
        },
        [BUTTON_POSITIONS.TRAILING]: {
          borderRadius: '0 $2 $2 0',
        },
      },
    },
  }
);
